import React from 'react';
import { Card, CardContent } from './ui/card';
import { cn } from '@/lib/utils';
import { Check, Package, Sparkles, Rocket, MessageSquare } from 'lucide-react';

const packageIcons = {
  'starter-presence': Package,
  'brand-visibility': Sparkles,
  'growth-marketing': Rocket,
  'custom': MessageSquare
};

export const PackageCard = ({ pkg, isSelected, onSelect }) => {
  const IconComponent = packageIcons[pkg.id] || Package;

  return (
    <Card
      onClick={() => onSelect(pkg.id)}
      className={cn(
        'cursor-pointer transition-all duration-300 overflow-hidden',
        'hover:shadow-sm border',
        isSelected
          ? 'border-emerald-500 bg-emerald-50/50'
          : 'border-slate-200 hover:border-slate-300'
      )}
    >
      <CardContent className="p-3">
        <div className="flex items-start gap-2">
          <div
            className={cn(
              'p-1.5 rounded-md transition-colors flex-shrink-0',
              isSelected ? 'bg-emerald-100' : 'bg-slate-100'
            )}
          >
            <IconComponent
              className={cn(
                'h-4 w-4 transition-colors',
                isSelected ? 'text-emerald-600' : 'text-slate-500'
              )}
            />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between gap-1">
              <h3
                className={cn(
                  'font-semibold text-xs transition-colors truncate',
                  isSelected ? 'text-emerald-900' : 'text-slate-800'
                )}
              >
                {pkg.name}
              </h3>
              <span
                className={cn(
                  'text-[10px] font-medium px-1.5 py-0.5 rounded whitespace-nowrap',
                  isSelected
                    ? 'bg-emerald-200 text-emerald-800'
                    : 'bg-slate-200 text-slate-700'
                )}
              >
                {pkg.priceRange}
              </span>
            </div>
            <p className="text-[10px] text-slate-500 mt-0.5 truncate">{pkg.description}</p>
          </div>
        </div>

        {/* Highlights */}
        <div
          className={cn(
            'mt-2 pt-2 border-t transition-colors',
            isSelected ? 'border-emerald-200' : 'border-slate-100'
          )}
        >
          <ul className="space-y-1">
            {pkg.highlights.map((highlight, idx) => (
              <li key={idx} className="flex items-start gap-1.5 text-[10px]">
                <Check
                  className={cn(
                    'h-3 w-3 flex-shrink-0 mt-0',
                    isSelected ? 'text-emerald-500' : 'text-slate-400'
                  )}
                />
                <span className="text-slate-600 leading-tight">{highlight}</span>
              </li>
            ))}
          </ul>
        </div>
      </CardContent>
    </Card>
  );
};
